import { useCallback } from 'react'

import { eventLogsService } from '../../api'
import { ActivityLogCard } from '../event-logs/activity-log-card'

export function UserActivityLog({ userId }: { userId: string }) {
  const fetchEvents = useCallback(
    () => eventLogsService.getEventLogsByUser(userId, { limit: '100' }),
    [userId],
  )

  return (
    <ActivityLogCard
      title="Account Activity"
      emptyMessage="No activity recorded for this user"
      columns={['time', 'level', 'event', 'message', 'actor', 'link']}
      fetchEvents={fetchEvents}
    />
  )
}
